<template>
  <div class="model-box">
    <table class="model-table">
      <td class="model-table-header">
        <tr>
          <el-tooltip class="item" :content="$t('T_MODEL_NAME')" effect="dark" placement="top-start">
            <span>{{$t('T_MODEL_NAME')}}</span>
          </el-tooltip>
        </tr>
        <tr>
          <el-tooltip class="item" :content="$t('T_IMAGE')" effect="dark" placement="top-start">
            <span class="table-img">{{$t('T_IMAGE')}}</span>
          </el-tooltip>
        </tr>
        <tr>
          <el-tooltip class="item" :content="$t('T_INFO_RESOLUTION')" effect="dark" placement="top-start">
            <span>{{$t('T_INFO_RESOLUTION')}}</span>
          </el-tooltip>
        </tr>
        <tr>
          <el-tooltip class="item" :content="$t('T_INFO_BRIGHTNESS')" effect="dark" placement="top-start">
            <span>{{$t('T_INFO_BRIGHTNESS')}}</span>
          </el-tooltip>
        </tr>
        <tr>
          <el-tooltip class="item" :content="$t('T_LENS_SHIFT')" effect="dark" placement="top-start">
            <span>{{$t('T_LENS_SHIFT')}}</span>
          </el-tooltip>
        </tr>
        <tr>
          <el-tooltip class="item" :content="$t('T_OTHER_SEPC')" effect="dark" placement="top-start">
            <span>{{$t('T_OTHER_SEPC')}}</span>
          </el-tooltip>
        </tr>
        <tr><span>&nbsp;</span></tr>
      </td>
      <td>
        <tr><span>{{$t('T_MODEL_NAME')}}</span></tr>
        <tr><span class="table-img">{{$t('T_IMAGE')}}</span></tr>
        <tr><span>{{$t('T_INFO_RESOLUTION')}}</span></tr>
        <tr><span>{{$t('T_INFO_BRIGHTNESS')}}</span></tr>
        <tr><span>{{$t('T_LENS_SHIFT')}}</span></tr>
        <tr><span>{{$t('T_OTHER_SEPC')}}</span></tr>
        <tr><span>&nbsp;</span></tr>
      </td>
      <td v-for="(item, index) in list" :key="index">
        <tr>
          <el-tooltip class="item" effect="dark" :content="getModelLabel(item.name)" placement="top-start">
            <span>{{getModelLabel(item.name)}}</span>
          </el-tooltip>
        </tr>
        <tr><span class="table-img"><img :src="item.url + '.jpg'"></span></tr>
        <tr><span>{{item.resolution}}</span></tr>
        <tr><span>{{item.brightness}}{{$t('T_LUMEN')}}</span></tr>
        <tr>
          <el-tooltip class="item" effect="dark" :content="item.lensShiftAvailable ==='Available'? $t('T_AVAILABLE'):$t('T_DISABLE')" placement="top-start">
            <span v-if="item.lensShiftAvailable ==='Available'">{{$t('T_AVAILABLE')}}</span>
            <span v-else>{{$t('T_DISABLE')}}</span>
          </el-tooltip>
        </tr>
        <tr>
          <el-tooltip class="item" :content="$t('T_SPEC_INFO')" effect="dark" placement="top-start">
            <span>
              <el-button type="primary" size="mini" @click="goToDetail(item)" class="mini_button">{{$t('T_SPEC_INFO')}}
              </el-button>
            </span>
          </el-tooltip>
        </tr>
        <tr><span>
            <el-button type="button" @click="changeSelectModel(item)">{{$t('T_SELECT')}}</el-button>
          </span></tr>
      </td>
    </table>
    <el-dialog width="33%" :visible.sync="detailDialogVisible" class="model-list slot-title" center
      :close-on-click-modal="false" append-to-body>
      <div class="info" slot="title">
        <div class="projector-title">{{$t('T_PROJECTOR_INFO')}}</div>
        <div class="detail-img-box">
          <img :src="detailObj.url + '.jpg'" width="120px">
        </div>
        <p>{{getModelLabel(detailObj.name)}}</p>
      </div>
      <el-tabs v-model="activeName" type="card" stretch>
        <el-tab-pane :label="$t('T_BASIC_SPEC')" name="first">
          <div class="detailedInfo" v-for="(value, name, index) in mainSpecData" :key="index">
            <span>{{ $t(name) }} :</span>
            <span v-if="value==='Laser Diode'">{{ $t('T_LIGHT_TYPE_LASER') }}</span>
            <span v-else-if="value==='Lamp'">{{ $t('T_LIGHT_TYPE_LASER') }}</span>
            <span v-else>{{ value }}</span>
            <span v-if="name === 'T_INFO_BRIGHTNESS'">{{ $t('T_LUMEN') }}</span>
            <hr />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('T_INTERFACE')" name="second">
          <div class="detailedInfo" v-for="(value, name, index) in interfaceSpecData" :key="index">
            <span>{{ $t(name) }} :</span>
            <span v-if="value">{{ value }}</span>
            <span v-else>{{ $t('T_NOTHING') }}</span>
            <hr />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('T_FUNCTION')" name="third">
          <div class="detailedInfo" v-for="(value, name, index) in functionSpecData" :key="index">
            <span>{{ $t(name) }} :</span>
            <span v-if="value">{{ $t('T_YES') }}</span>
            <span v-else>{{ $t('T_NO') }}</span>
            <hr />
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailDialogVisible = false">{{$t('T_OK')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['list'],

  data () {
    return {
      detailDialogVisible: false,
      detailObj: this.list[0],
      activeName: 'first',
      mainSpecData: {},
      interfaceSpecData: {},
      functionSpecData: {}
    }
  },

  methods: {
    changeSelectModel (data) {
      this.$emit('change', data)
    },

    goToDetail (data) {
      this.activeName = 'first'
      this.detailDialogVisible = true
      this.detailObj = data
      this.mainSpecData = {
        'T_INFO_BRIGHTNESS': this.detailObj['color'],
        'T_INFO_CONTRAST': this.detailObj['contrast'],
        'T_INFO_RESOLUTION': this.detailObj['resolution'],
        'T_INFO_LIGHT_TYPE': this.detailObj['lightType'],
        'T_INFO_WEIGHT': this.detailObj['weightIncludingLens'],
        'T_INFO_SIZE': this.detailObj['maxDimension'],
        'T_INFO_POWER_SUPPLY': this.detailObj['supplyVoltage'],
        'T_INFO_POWER_CONSUMPTION': this.detailObj['consumption220'] + '/' + this.detailObj['consumption220_eco'],
        'T_INFO_FAN_NOISE': this.detailObj['fanNoise']
      }
      this.interfaceSpecData = {
        'T_INFO_RGB': this.detailObj['inputRgb'],
        'T_INFO_HDMI': this.detailObj['inputHdmi'],
        'T_INFO_VIDEO': this.detailObj['inputVideo'],
        'T_INFO_USBA': this.detailObj['inputUsbA'],
        'T_INFO_HDBASET': this.detailObj['inputHdBaseT'],
        'T_INFO_WIRED_LAN': this.detailObj['inputWiredLan'],
        'T_INFO_WIRELESS_LAN': this.detailObj['inputWirelessLan']
      }
      this.functionSpecData = {
        'T_INFO_PC_FREE': this.detailObj['PCFREE'],
        'T_INFO_APP_FOR_PC': this.detailObj['iProjectionForPC'],
        'T_INFO_APP_FOR_IOS': this.detailObj['iProjectionForIOS'],
        'T_INFO_APP_FOR_ANDROID': this.detailObj['iProjectionForAndroid']
      }
    },
    getModelLabel (label) {
      return this.$commonJs.getModelLabelByName(label)
    }
  }
}
</script>
<style type="text/css">
  .model-list .el-dialog__header {
    padding: 15px 0px 15px 0px;
    background: #005ab4;
  }

  .model-list .el-dialog__title,
  .model-list .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }

  .info {
    color: #fff;
  }

  .model-table {
    border-collapse: collapse;
    font-size: 0;
  }

  .model-table-header {
    position: absolute;
    left: 25px;
    z-index: 111;
    background: #fff;
    top: 25px;
  }

  .model-table tr {
    border: 1px solid #ccc;
  }

  .model-table tr>span {
    width: 100px;
    text-align: center;
    display: inline-block;
    font-size: 14px;
    height: 35px;
    line-height: 35px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .model-table .table-img {
    width: 100px;
    height: 100px;
    line-height: 100px;
    display: table-cell;
  }

  .table-img img {
    width: 90px;
    vertical-align: middle;
  }

  .model-box {
    width: 100%;
    overflow: auto;
  }

  .detail-img-box {
    width: 120px;
    height: 120px;
    background: rgb(255, 255, 255);
    position: relative;
    margin: 0 auto;
  }

  .detail-img-box img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .detailedInfo {
    text-align: left;
  }

  .detailedInfo span {
    height: 36px;
    line-height: 36px;
    text-align: left;
  }

  .mini_button span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #tab-first {
    width: 220px;
  }

</style>



// WEBPACK FOOTER //
// src/view/searchTabs/comparisonModelTable.vue